/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Contact_DeactivateInputs */

const en_case_contact_deactivate = /** @type {(inputs: Case_Contact_DeactivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deactivate contact`)
};

const pt_br2_case_contact_deactivate = /** @type {(inputs: Case_Contact_DeactivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desativar contato`)
};

/**
* | output |
* | --- |
* | "Deactivate contact" |
*
* @param {Case_Contact_DeactivateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_contact_deactivate = /** @type {((inputs?: Case_Contact_DeactivateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Contact_DeactivateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_contact_deactivate(inputs)
	return pt_br2_case_contact_deactivate(inputs)
});